'use server';

import { apiFetch } from '@/lib/api';
import {
  CreateFeedbackFormSchema,
  CreateFeedbackFormState,
} from '@/lib/definitions/feedback';

export async function actionCreateFeedback(
  prevState: CreateFeedbackFormState,
  formData: FormData
): Promise<any> {
  const validatedFields = CreateFeedbackFormSchema.safeParse({
    message: formData.get('message'),
    feedbackType: formData.get('feedbackType'),
  });

  if (!validatedFields.success) {
    console.error(
      'Falha ao criar feedback:',
      validatedFields.error.flatten().fieldErrors
    );

    return {
      success: false,
      values: prevState?.values || {},
      errors: validatedFields.error.flatten().fieldErrors,
    };
  }

  const response = await apiFetch('/feedback', {
    method: 'POST',
    body: JSON.stringify({
      message: validatedFields.data.message,
      feedback_type: validatedFields.data.feedbackType,
    }),
  });

  const body = await response.json();

  if (!response.ok) {
    return {
      success: false,
      values: prevState?.values || {},
      errors: JSON.stringify(body.detail) || 'Falha ao criar feedback',
    };
  }

  return {
    success: true,
    values: body,
    message: 'Feedback enviado com sucesso.',
  };
}
